import React from "react";
import AddRepairingOrder from "./AddRepairingOrder";

// RepairingSales reuses the AddRepairingOrder UI as requested
// Prefill via location.state.repairingOrderId is handled in AddRepairingOrder
const RepairingSales = ({ masterGoldRate, masterSilverRate }) => {
  return (
    <AddRepairingOrder
      masterGoldRate={masterGoldRate}
      masterSilverRate={masterSilverRate}
      isRepairingSale={true}
    />
  );
};

export default RepairingSales;


